import { CellContext } from "@/lib/Components/DataTable/types";

export function DeEmphasisedCell({ getValue }: CellContext<any, any>) {
  return <div className="text-gray-500">{getValue()}</div>;
}
